import Box from 'app/components/base/Box'
import Text from 'app/components/base/Text'

const Tag: RFC<{ tag: string }> = ({ tag }) => {
  return (
    <Box
      sx={{
        py: '7px',
        px: 1.5,
        backgroundColor: '#b2f8dd',
        borderRadius: '8px',
        mr: 1,
        mb: 1
      }}
    >
      <Text variant="body2" sx={{ fontWeight: 500 }} noWrap>
        {tag}
      </Text>
    </Box>
  )
}

export default Tag
